import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogRef } from "primeng/dynamicdialog";
import { DataService_Staff_DigitalID } from "../../shared/data.service";

@Component({
	selector: "caass-staff-digital-id-download",
	templateUrl: "./staff-digital-id-download.component.html",
	styleUrls: ["./staff-digital-id-download.component.css"],
})
export class StaffDigitalIdDownloadComponent implements OnInit {
	constructor(private idService: DataService_Staff_DigitalID, private ref: DynamicDialogRef, private confirmationService: ConfirmationService) {}

	ngOnInit(): void {
		this.loadFormatOptions();
	}

	/////////////////////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////////////////////

	LoadingOptions: any = true;
	IsProcessing: any = false;

	FormatOption: any;
	lstFormatOptions: any = [];

	errorMessage: any = "";

	/////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////
	// Load Data
	/////////////////////////////////////////////////////////////////////

	loadFormatOptions() {
		this.LoadingOptions = true;

		var result = this.idService.ExportFormatOptionSelectList();
		result.subscribe(
			(response) => {
				this.LoadingOptions = false;

				this.lstFormatOptions = response;

				for (var z = 0; z < this.lstFormatOptions.length; z++) {
					var next = this.lstFormatOptions[z];

					if (next.Selected == true) {
						this.FormatOption = next;
						break;
					}
				}
			},
			(error) => {
				this.LoadingOptions = false;
			}
		);
	}

	/////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////////////////////////////////

	onDownload() {
		this.ref.close(this.FormatOption);
	}

	onClose() {
		this.errorMessage = "";

		this.ref.close("close");
	}
	/////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////
	// Helpers
	/////////////////////////////////////////////////////////////////////

	IsLoading() {
		return this.LoadingOptions == true || this.IsProcessing == true;
	}

	/////////////////////////////////////////////////////////////////////
}
